import { EIcons } from "@atoms/ZIcon/interface";

export enum EFooterVariant {
	IMPORT_ZBUTTON = "import_zbutton"
}

export interface IZImportFooterProps {
	variant: EFooterVariant;
	buttonText: string;
	onClick: () => void;
	disabled?: boolean;
	isLoading?: boolean;
	showAiDisclaimer?: boolean;

	iconName?: EIcons;
	iconProps?: any;
	className?: string;
}
